var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinNodeOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14033_27790)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14033_27790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 5.8 5.8 0 13 0C20.2 0 26 5.8 26 13C26 20.2 20.2 26 13 26C5.8 26 0 20.2 0 13Z",
    fill: "#979797",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3 5.80078H8.00002H6.70002C6.50002 5.80078 6.40002 5.90078 6.40002 6.10078V6.70078V9.30078V18.7008C6.40002 18.9008 6.50002 19.0008 6.70002 19.0008H10.9L13 20.7008L15.2 19.0008H16.2H18.7H19.3C19.5 19.0008 19.6 18.9008 19.6 18.7008V17.4008V6.10078C19.6 5.90078 19.5 5.80078 19.3 5.80078Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 4.80078C20.4 4.50078 20 4.30078 19.5 4.30078H6.50005C6.00005 4.30078 5.60005 4.40078 5.30005 4.80078C5.00005 5.10078 4.80005 5.50078 4.80005 6.00078V19.0008C4.80005 19.4008 5.00005 19.8008 5.30005 20.2008C5.60005 20.6008 6.00005 20.7008 6.50005 20.7008H10.2L13 23.5008L15.8 20.7008H19.5C19.9 20.7008 20.3 20.5008 20.7 20.2008C21 19.9008 21.2001 19.5008 21.2001 19.0008V6.00078C21.2001 5.50078 21 5.10078 20.7 4.80078ZM19.6 17.4008V18.7008C19.6 18.9008 19.5 19.0008 19.3 19.0008H18.7H16.2H15.2L13 20.7008L10.9 19.0008H6.70005C6.50005 19.0008 6.40005 18.9008 6.40005 18.7008V9.20078V6.70078V6.10078C6.40005 5.90078 6.50005 5.80078 6.70005 5.80078H8.00005H19.3C19.5 5.80078 19.6 5.90078 19.6 6.10078V17.4008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 9H10.4H9.5V10V15V16H10.4H15.6H16.5V15V10V9H15.6ZM14.9 11.1V13.9V14.5H14.4H11.5H11V13.9V11.1V10.5H11.5H14.4H14.9V11.1Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14033_27790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14033_27790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinNodeOffline);
export default __webpack_public_path__ + "static/media/pin_node_offline.2a4ba99223bfd0043fe45b633a1a08fd.svg";
export { ForwardRef as ReactComponent };